import colors from './colors';
import images from './images';
import copy from './copy';

/** 定制蓝 — 参考 收银台 设计稿 */
export default {
  id: 'custom-blue',
  name: 'Custom Blue',
  code: 'X5mG9qL2',

  colors,
  copy,

  gradients: {
    card: `linear-gradient(135deg, ${colors.primary} 0%, ${colors.primaryLight} 100%)`,
    btnPrimary: `linear-gradient(180deg, ${colors.primaryLight} 0%, ${colors.primaryDeep} 100%)`,
    btnStrong: `linear-gradient(180deg, ${colors.primaryBright} 0%, ${colors.primary} 100%)`,
    copyBtn: `linear-gradient(180deg, ${colors.accentYellow} 0%, ${colors.accentYellowDark} 100%)`,
  },

  images,
};
